import "../../assets/index3.css";
import { j as t } from "../../jsx-runtime-82a9ddf6.js";
import { k as e } from "../../react-toastify.esm-a636d9b1.js";
import { cva as s } from "../../lib/cn.js";
const o = s(
  ""
), m = () => /* @__PURE__ */ t.jsx(
  e,
  {
    toastClassName: () => `${o()}`,
    className: "!z-[9999999999999] min-w-[400px] md:min-w-[100%] md:p-0 md:bottom-0",
    bodyClassName: () => "w-full text-sm font-white font-med flex [&>div]:flex [&>div]:w-full",
    position: "bottom-center",
    autoClose: 2500,
    icon: !1,
    hideProgressBar: !0,
    newestOnTop: !0,
    closeOnClick: !0,
    rtl: !1,
    pauseOnFocusLoss: !0,
    draggable: !1,
    pauseOnHover: !1,
    theme: "light",
    closeButton: !1
  }
);
export {
  m as ToastContainer,
  m as default
};
